import {message, ModalProps, Skeleton} from 'antd';
import React from 'react';
import Style from './index.module.scss';
import FormRender, {Schema, useForm} from 'form-render';
import {useMutation, useQuery} from 'react-query';
import {ProModal} from '../../../../../../Components/ProModal';
import {getServerUuid, saveServerUuid} from '../../../service';

interface Props extends ModalProps {
    customerId: string;
    onOk: () => void;
}

const help =
    '填写说明：\n' +
    '\n' +
    '如果多个 UUID，请用“;”间隔，输入内容参考如下\n' +
    '\n' +
    'd31bce98-f12b-471a-a24f-bd644aa38070;d31bce98-f12b-471a-a24f-bd644aa38071;d31bce98-f12b-471a-a24f-bd644aa38072;d31bce98-f12b-471a-a24f-bd644aa38073;d31bce98-f12b-471a-a24f-bd644aa38074;d31bce98-f12b-471a-a24f-bd644aa38075;d31bce98-f12b-471a-a24f-bd644aa38076;d31bce98-f12b-471a-a24f-bd644aa38078;d31bce98-f12b-471a-a24f-bd644aa38070';

const Index = ({customerId, onOk, ...props}: Props) => {
    const form = useForm();

    const onSave = useMutation({
        mutationFn: saveServerUuid,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const defaultData = useQuery({
        queryKey: ['getTenant', customerId],
        queryFn: () => getServerUuid(customerId),
        onSuccess: res => {
            form.setValues(res);
        },
    });

    const schema: Schema = {
        type: 'object',
        column: 1,
        displayType: 'row',
        labelCol: 6,
        fieldCol: 15,
        properties: {
            serverUuid: {
                title: '服务器UUID',
                type: 'string',
                widget: 'textArea',
                extra: help,
                required: true,
                props: {
                    rows: 10,
                },
            },
        },
    };

    return (
        <ProModal
            {...props}
            title="维护服务器UUID"
            onOk={form.submit}
            width={1000}>
            <div className={Style.root}>
                <Skeleton active loading={defaultData?.isFetching}>
                    <FormRender
                        form={form}
                        schema={schema}
                        onFinish={formData =>
                            onSave.mutate({
                                ...formData,
                                customerId,
                            })
                        }
                        footer={false}
                    />
                </Skeleton>
            </div>
        </ProModal>
    );
};

export default Index;
